/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Pick_FirstInputs */



/**
* | output |
* | --- |
* | "Choose a partner and at least one customer." |
*
* @param {Admin_Export_Pick_FirstInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_pick_first = /** @type {((inputs?: Admin_Export_Pick_FirstInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Pick_FirstInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Partner und mindestens einen Kunden.")
	return /** @type {LocalizedString} */ ("Choose a partner and at least one customer.")
});